import { makePath } from '@feedyou/utils'
import { TimeoutStepSchema } from '@feedyou/schema'

import { getUsedDialogs } from './getUsedDialogs'
import { GetSubdialogConnectionsMetadata } from '../../../types'

export const getSubdialogConnectionsMetadata: GetSubdialogConnectionsMetadata<TimeoutStepSchema> = (
  step,
  parentDialogId
) => {
  return [...getUsedDialogs(step)].map(dialog => {
    return {
      parentDialog: parentDialogId,
      childDialog: dialog,
      checkpointLink: makePath(step.id)
    }
  })
}
